module.exports = __webpack_public_path__ + "static/media/Unforgettable-Gift.ab52e31d.png";